import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Spinner from '../../../components/Spinner';
import isCompanyVisible from '../../../utils/isCompanyVisible';
import { subrateDrivers, subrateTrailer, subrateJuridical, subrateProlong } from '../../../settings/profins';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    //paddingTop: theme.spacing(3)
  },
  marginTop: {
    marginTop: '20px'
  },
  chip: {
    marginRight: '2px', marginBottom: '4px'
  },
  tooltipLink: {
    cursor: 'pointer',
    color: 'black',
    textDecoration: 'none',
  }
}));

const RateInfo = (props) => {

  const classes = useStyles();
  const curRate = props.infoRate;

  const catalogsCompanies = props.catalogs['companies'] ?? false;
  const catalogsRegions = props.catalogs['regions'] ?? false;
  const catalogsGeneral = props.catalogs['general'] ?? false;

  let curRateBlock = <Grid item lg={12} md={12} xs={12} ><Spinner text="Загружаем информацию о комиссионном вознаграждении"></Spinner></Grid>

  if (curRate) {

    let subrates = null;
    //let otherText = " стоимости полиса идёт вам";
    if (curRate.rates) {

      const curRates = {};
      for (const i in curRate.rates) 
        curRates[curRate.rates[i].id] = curRate.rates[i];

      if (!curRate.parent_rates) curRate.parent_rates = curRates;

      // Как в основном тарифе: сравниваем company_id числом и берём ставки и из rates, и из parent_rates.
      const subratesById = {};
      const addSubrateSource = (collection) => {
        if (!collection) return;
        const list = Array.isArray(collection) ? collection : Object.keys(collection).map((k) => collection[k]);
        for (let n = 0; n < list.length; n++) {
          const item = list[n];
          if (!item || item.company_id === undefined || item.company_id === null || item.id === undefined) continue;
          if (!subratesById[item.id]) subratesById[item.id] = item;
        }
      };
      addSubrateSource(curRate.parent_rates);
      addSubrateSource(curRate.rates);
      const allSubrates = Object.keys(subratesById).map((k) => subratesById[k]);

      const ensureArray = (value) => {
        if (Array.isArray(value)) return value;
        if (value == null || value === '') return [0];
        if (typeof value === 'string') {
          try {
            const parsed = JSON.parse(value);
            return Array.isArray(parsed) ? parsed : [parsed];
          } catch (e) {
            return [0];
          }
        }
        return [value];
      };

      //otherText = " в остальных случаях";
      const specialTariffs = [];
      for (const companyId in catalogsCompanies) if (isCompanyVisible(props.curUser, companyId)) {

        specialTariffs.push(<Box key={"st" + companyId} style={{marginTop:"20px", marginBottom:"5px"}}><Typography variant="h4">{catalogsCompanies[companyId].name}</Typography></Box>);

        for (let si = 0; si < allSubrates.length; si++) if (companyId * 1 === allSubrates[si].company_id * 1) {
          const parentRate = allSubrates[si];
          const regionIds = ensureArray(parentRate.region_id);
          const categoryIds = ensureArray(parentRate.category);
          const taskIds = ensureArray(parentRate.task);
          const prolongIds = ensureArray(parentRate.prolong);
          const regionTariffs = [];
          let allRegions = false;
          for (const j in regionIds) {
            const regionId = regionIds[j];
            //console.log("REGION ID", regionId);
            if (regionId > 0) {     
              regionTariffs.push(catalogsRegions[regionId] ? (
              <Chip className={classes.chip} key={"j"+regionId} label={catalogsRegions[regionId].name} />
              ) : null);
            } else { 
              allRegions = true;
              regionTariffs.push(<Chip className={classes.chip} key={"j"+j} label="Все регионы" />);
            }
          }

          const categoryTariffs = [];
          for (const j in categoryIds) {
            const categoryId = categoryIds[j];
            if (categoryId !== "0") {     
              categoryTariffs.push(catalogsGeneral['car_categories'][categoryId] ? <Chip className={classes.chip} key={"f"+catalogsGeneral['car_categories'][categoryId].id} label={catalogsGeneral['car_categories'][categoryId].name} /> : null);
            } else { 
              categoryTariffs.push(<Chip className={classes.chip} key={"f"+j} label="Все категории" />);
            }
          }

          const taskTariffs = [];
          for (const j in taskIds) {
            const taskId = taskIds[j];
            if (taskId !== "0") {     
              taskTariffs.push(catalogsGeneral['car_tasks'][taskId] ? <Chip className={classes.chip} key={"g"+catalogsGeneral['car_tasks'][taskId].id} label={catalogsGeneral['car_tasks'][taskId].name} /> : null);
            } else { 
              taskTariffs.push(<Chip className={classes.chip} key={"g"+j} label="Все цели использования" />);
            }
          }

          const prolongTariffs = [];
          for (const j in prolongIds) {
            const prolongId = prolongIds[j];
            if (prolongId !== "0") {     
              prolongTariffs.push(catalogsGeneral['prolong'][prolongId] ? <Chip className={classes.chip} key={"g"+catalogsGeneral['prolong'][prolongId].id} label={catalogsGeneral['prolong'][prolongId].name} /> : null);
            } else { 
              prolongTariffs.push(<Chip className={classes.chip} key={"g"+j} label="Все варианты" />);
            }
          }

          const otherTariffs = [];
          if (parentRate.trailer > 0) otherTariffs.push(<Chip className={classes.chip} key={"a"+parentRate.trailer} label={subrateTrailer[parentRate.trailer].name} />);
          if (parentRate.juridical > 0) otherTariffs.push(<Chip className={classes.chip} key={"b"+parentRate.juridical} label={subrateJuridical[parentRate.juridical].name} />);
          //if (curRate.rates[i].prolong > 0) otherTariffs.push(<Chip className={classes.chip} key={"c"+parentRate.prolong} label={subrateProlong[parentRate.prolong].name} />);
          if (parentRate.drivers > 0) otherTariffs.push(<Chip className={classes.chip} key={"d"+parentRate.drivers} label={subrateDrivers[parentRate.drivers].name} />);
          if (parentRate.power > 0) otherTariffs.push(<Chip className={classes.chip} key={"e"+parentRate.power} label={"Мощность от " + parentRate.power} />);
          if (parentRate.kbm > 0) otherTariffs.push(<Chip className={classes.chip} key={"f"+parentRate.kbm} label={"КБМ до " + parentRate.kbm} />);
          if (parentRate.reinsurance > 0) otherTariffs.push(<Chip className={classes.chip} key={"reinsurance"+parentRate.id} label="Перестрахование" />);

          let tariffText = '';
          let specialBlock = null;

          if (!props.readOnly) {

            const editedParentRates = (props.editedRate && props.editedRate.parent_rates) ? props.editedRate.parent_rates : {};
            const editedParent = editedParentRates[parentRate.id] || editedParentRates[String(parentRate.id)] || parentRate;
            let finalPercent = editedParent.percent*1 - (props.editedRate ? props.editedRate.percent*1 : 0);
            if (props.specialSettings) {
              const specialTariffs = props.specialSettings.filter((element)=>element.subrate_id*1===parentRate.id*1);
              let specialTariffPercent = 0;
              if (specialTariffs.length > 0) specialTariffPercent = specialTariffs[0].percent;
              specialBlock = <input onChange={(event)=>props.changeSpecialSubrate(parentRate.id, event.target.value)} style={{width:"30px"}} value={specialTariffPercent !==0 ? specialTariffPercent : ""}  />
              finalPercent += specialTariffPercent*1;
            }
            tariffText += (parentRate.percent || 0) + "% ("+finalPercent+"%)";
            
          } else {

            tariffText += Math.max(0, (parentRate.percent || 0)) + "%";

          }

          tariffText += " в " + (allRegions ? "любом регионе" : (regionIds.length + (regionIds.length === 1 ? " регионе" : " регионах")));
          if (parentRate.reinsurance > 0) tariffText += ", ПЕРЕСТРАХОВАНИЕ";

          specialTariffs.push(
            <Accordion key={"subrate-" + parentRate.id}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>{specialBlock} {tariffText}</Typography>
              </AccordionSummary>
              <AccordionDetails style={{display: 'block'}}>
                {regionTariffs}
                {categoryTariffs}
                {taskTariffs}
                {prolongTariffs}
                {otherTariffs}
              </AccordionDetails>
            </Accordion>);
        }
      }

      subrates = <Grid item lg={12} md={12} xs={12} >{specialTariffs}</Grid>
    }
    curRateBlock = <>
      {/*<Grid item lg={12} md={12} xs={12} >
        <Typography variant="h4" component="p">Комиссионное вознаграждение "{curRate.name}"</Typography>
      </Grid>*/}
      {subrates}
      {/*<Grid item lg={12} md={12} xs={12} >
        <Typography variant="body1" component="p">{curRate.percent}% {otherText}</Typography>
      </Grid>*/}
    </>
  }

  return curRateBlock;
};

const mapStateToProps = state => {
  return {
      curUser: state.auth.user,
      catalogs: state.catalogs.catalogs,
  }
}

export default connect(mapStateToProps)(RateInfo);